import { useMutation, useQuery } from '@tanstack/react-query';

import { listingsApi, type ListingFilters } from '@/api/listings';

export function useListings(filters: ListingFilters = {}) {
  return useQuery({
    queryKey: ['listings', filters],
    queryFn: () => listingsApi.list(filters),
  });
}

export function useListing(id: number | null) {
  return useQuery({
    queryKey: ['listing', id],
    queryFn: () => listingsApi.get(id as number),
    enabled: id !== null,
  });
}

export function useApplyToListing() {
  return useMutation({
    mutationFn: ({ id, message }: { id: number; message?: string }) =>
      listingsApi.apply(id, { message }),
  });
}
